// Homepage testimonial slider. 04.10.2026: now exits quietly on pages without the slider, instead of throwing an error on every other page.
(function () {
  "use strict";
  var testim = document.getElementById("testim");
  var dotsEl = document.getElementById("testim-dots");
  var contentEl = document.getElementById("testim-content");
  if (!testim || !dotsEl || !contentEl) return;

  var testimDots = Array.prototype.slice.call(dotsEl.children),
    testimContent = Array.prototype.slice.call(contentEl.children),
    testimLeftArrow = document.getElementById("left-arrow"),
    testimRightArrow = document.getElementById("right-arrow"),
    testimSpeed = 4500,
    currentSlide = 0,
    currentActive = 0,
    testimTimer,
    touchStartPos,
    touchEndPos,
    touchPosDiff,
    ignoreTouch = 30;

  function playSlide(slide) {
    for (var k = 0; k < testimDots.length; k++) {
      testimContent[k].classList.remove("active");
      testimContent[k].classList.remove("inactive");
      testimDots[k].classList.remove("active");
    }
    if (slide < 0) { slide = currentSlide = testimContent.length - 1; }
    if (slide > testimContent.length - 1) { slide = currentSlide = 0; }
    if (currentActive != currentSlide) { testimContent[currentActive].classList.add("inactive"); }
    testimContent[slide].classList.add("active");
    testimDots[slide].classList.add("active");
    currentActive = currentSlide;
    clearTimeout(testimTimer);
    testimTimer = setTimeout(function () { playSlide((currentSlide += 1)); }, testimSpeed);
  }

  function start() {
    if (testimLeftArrow) testimLeftArrow.addEventListener("click", function () { playSlide((currentSlide -= 1)); });
    if (testimRightArrow) testimRightArrow.addEventListener("click", function () { playSlide((currentSlide += 1)); });
    for (var l = 0; l < testimDots.length; l++) {
      testimDots[l].addEventListener("click", function () { playSlide((currentSlide = testimDots.indexOf(this))); });
    }
    if (testimContent.length) playSlide(currentSlide);

    document.addEventListener("keyup", function (e) {
      if (e.key === "ArrowLeft" && testimLeftArrow) testimLeftArrow.click();
      if (e.key === "ArrowRight" && testimRightArrow) testimRightArrow.click();
    });

    testim.addEventListener("touchstart", function (e) { touchStartPos = e.changedTouches[0].clientX; }, { passive: true });
    testim.addEventListener("touchend", function (e) {
      touchEndPos = e.changedTouches[0].clientX;
      touchPosDiff = touchStartPos - touchEndPos;
      if (touchPosDiff > ignoreTouch && testimLeftArrow) { testimLeftArrow.click(); }
      else if (touchPosDiff < -ignoreTouch && testimRightArrow) { testimRightArrow.click(); }
    }, { passive: true });
  }

  if (document.readyState === "complete") { start(); } else { window.addEventListener("load", start); }
})();
